<template>
  <div class="news-card" @click.stop="goDetail(newsDetail.id)">
    <div class="img-wrapper">
      <img v-lazy="newsDetail.coverIcon" class="img lazy-img-fadein" />
    </div>
    
    <div class="footer">
      <div class="news-title ellipsis-2">{{ newsDetail.title }}</div>
      <div class="news-date">{{ formatDate(newsDetail.createTime) }}</div>
    </div>
    
  </div>
</template>
<script>
export default {
  props: {
    newsDetail: {
      type: [Object],
      default: () => {}
    }
  },
  name: 'newsCard',

  data() {
    return {}
  },
  watch: {},
  mounted() {},
  methods: {
    goDetail(id) {
      this.$router.push(`/news/${id}`)
    },
    formatDate(date) {
      return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
    }
  }
}
</script>
<style lang="stylus" scoped>
.news-card
  width 100%
  transition all 0.3s
  overflow hidden
  margin-bottom 35px
  background $color-white
  box-shadow 0px 2px 6px 0px rgba(0,0,0,0.15)
  &:hover
    cursor pointer
    box-shadow 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2
    transition 0.3s all
    .news-title
      color $color-main
    .img
      transform: scale(1.2)
  .img-wrapper
    width 100%
    height 300px
    overflow hidden
  .img
    object-fit cover
    width 100%
    height 300px
    transition 0.3s all

  .footer
    width 100%
    height 82px
    position relative
  
  .news-title
    width 65%
    height 50px
    font-size 18px
    font-weight bold
    line-height 25px
    position absolute
    top 16px
    left 16px
    color $color-black-65

  .news-date
    position absolute
    bottom 12px
    right 12px
    font-size 13px
    font-weight bold
    color $color-black-25
</style>
